const num = value => Number(value) || 0

// Every foul of a player, as the team fouls count them: personal, technical and unsportsmanlike (the technical
// fouls of the coach and of the bench are on the team, with no player, and are not team fouls)
export function foulsOf(stats = {}) {
    // the unsportsmanlike foul before FIBA 2026, the disruptive (DI) and the flagrant (FL) one after
    return num(stats.personalFouls) + num(stats.technicalFouls) + num(stats.unsportsmanlikeFouls) +
        num(stats.disruptiveFouls) + num(stats.flagrantFouls)
}

const STAT_KEYS = [
    'points',
    'rebounds',
    'assists',
    'assistPoints',
    'secondChancePoints',
    'pointsOffTurnovers',
    'steals',
    'turnovers',
    'blockedShots',
    'twoPointsMade',
    'twoPointAttempts',
    'threePointsMade',
    'threePointAttempts',
    'freeThrowsMade',
    'freeThrowAttempts',
    'offensiveRebounds',
    'defensiveRebounds',
    'personalFouls',
    // every foul: personal, technical and unsportsmanlike
    'fouls',
    'pir',
    'playTimeInSecs'
]

export function getCummulativeStats(player) {
    const stats = STAT_KEYS.reduce((acc, key) => {
        acc[key] = 0
        return acc
    }, {})

    const playerStats = Array.isArray(player?.stats) ? player.stats : []
    playerStats.forEach(element => {
        STAT_KEYS.forEach(key => {
            stats[key] += key === 'fouls' ? foulsOf(element) : (element[key] || 0)
        })
    })

    return stats
}

export function getAverageStats(player) {
    const stats = getCummulativeStats(player)
    const playerStatsLength = Array.isArray(player?.stats) ? player.stats.length : 0

    STAT_KEYS.forEach(key => {
        stats[key] = playerStatsLength ? stats[key] / playerStatsLength : 0
    })

    return stats
}

export function calculateTeamStats(team) {
    const players = Array.isArray(team?.players) ? team.players : []
    players.forEach(player => {
        player.avg = getAverageStats(player)
        player.cum = getCummulativeStats(player)
    })
    return team
}

// The players worth watching before a match: active, not the coach, and with games played this season
export function watchablePlayers(team) {
    const players = Array.isArray(team?.players) ? team.players : []
    return players.filter(player => player.active !== false && !player.coach && Array.isArray(player.stats) && player.stats.length > 0)
}

// Whether the team has played a game this season, so its season averages have something to show
export function hasSeasonGames(team) {
    if ((Number(team?.seasonWins) || 0) + (Number(team?.seasonLoses) || 0) > 0) return true
    const players = Array.isArray(team?.players) ? team.players : []
    return players.some(player => Array.isArray(player.stats) && player.stats.length > 0)
}
